/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * This enum defines the run mode of the exam flow.
 */ 
export enum ExamFlowRunMode {
    /**
     * Default run mode. Every student will once go through every station.
     */ 
    Default = 1,
    /**
     * Single run mode. Every student will only go through one station.
     */ 
    SingleRun = 2,
    /**
     * NRun mode. Every student will only go through n stations.
     */ 
    NRun = 3,
}
